import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { StatusIndicator } from '@talismn/ui';
import { useMemo } from 'react';
export const StakeStatusIndicator = (props) => (_jsx(StatusIndicator, { ...props, status: useMemo(() => {
        switch (props.status) {
            case 'earning_rewards':
                return 'success';
            case 'waiting':
                return 'warning';
            case 'not_nominating':
            case 'not_earning_rewards':
                return 'error';
            case undefined:
                return undefined;
        }
    }, [props.status]), tooltip: useMemo(() => {
        switch (props.status) {
            case 'earning_rewards':
                return 'Earning rewards';
            case 'waiting':
                return 'Waiting';
            case 'not_nominating':
                return 'Not nominating';
            case 'not_earning_rewards':
                return 'Not earning rewards';
            case undefined:
                return '...';
        }
    }, [props.status]) }));
//# sourceMappingURL=StakeStatusIndicator.js.map